import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
@Injectable()
export abstract class LoggerHandlerServiceAbstract {
    log: Subject<unknown>;
    warning: Subject<unknown>;
    error: Subject<unknown>;
    fatal: Subject<unknown>;

    logCompleted: Subject<unknown>;
    warningCompleted: Subject<unknown>;
    errorCompleted: Subject<unknown>;
    fatalCompleted: Subject<unknown>;
}